import * as React from "react";

const IconPaginationArrowLeftLightHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M.685 8.182L0 7.502l.685-.68L6.873.68 7.558 0l1.365 1.356-.684.679-4.537 4.507H18v1.92H3.706l4.537 4.503.684.679L7.562 15l-.685-.68z"/></svg>;
};

export default React.memo(IconPaginationArrowLeftLightHover);
